<template>
	<div>
		<v-dialog v-model="visible" width="800" persistent>
			<v-card>
				<v-card-title>
					<v-icon style="margin-right: 10px"> {{ icon }} </v-icon>
					{{ '배너' }}
				</v-card-title>
				<v-form ref="form" v-model="formValid">
					<v-container>
						<v-row>
							<v-col class="item-content">
								<v-text-field v-model="item.id" label="배너 식별 값" type="text" filled disabled></v-text-field>
							</v-col>
							<v-col class="item-content">
								<v-text-field v-model="item.title" label="제목" type="text"></v-text-field>
							</v-col>
							<v-col class="item-content">
								<v-text-field
									v-model="item.layerHeight"
									:rules="[v => v >= 1 || '최소 크기는 200입니다']"
									label="레이어 높이"
									type="number"
									min="1"
									@input="validateInteger"
									@keypress="onlyAllowNumbers"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" :style="{ height: '350px' }">
								<ContentEditor :height="200" :value="textContent" @input="onChangeContent" v-model="item.content" />
							</v-col>
						</v-row>
						<v-row>
							<v-col class="item-content">
								<v-select
									v-model="item.bannerType"
									:items="bannerTypes"
									item-value="code"
									item-text="text"
									label="배너 유형"
									outlined
									@change="updateTypeName(item.bannerType, 'bannerTypeName', bannerTypes)"
								></v-select>
							</v-col>
							<v-col class="item-content">
								<v-select
									v-model="item.displayPositionType"
									:items="displayPositionTypes"
									item-value="code"
									item-text="text"
									label="노출 위치 유형"
									outlined
									@change="updateTypeName(item.displayPositionType, 'displayPositionTypeName', displayPositionTypes)"
								></v-select>
							</v-col>
							<v-col class="item-content">
								<v-select
									v-model="item.displayTargetUserType"
									:items="displayTargetUserTypes"
									item-value="code"
									item-text="text"
									label="노출 대상 사용자 유형"
									outlined
									@change="updateTypeName(item.displayTargetUserType, 'displayTargetUserTypeName', displayTargetUserTypes)"
								></v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="item-content">
								<v-select
									v-model="item.iconType"
									:items="iconTypes"
									item-value="code"
									item-text="text"
									label="아이콘 유형"
									outlined
									@change="updateTypeName(item.iconType, 'iconTypeName', iconTypes)"
								></v-select>
							</v-col>
							<v-col class="item-content">
								<v-text-field
									v-model="item.sort"
									:rules="[v => v >= 1 || '최소 크기는 1입니다']"
									label="정렬"
									type="number"
									min="1"
									@input="validateInteger"
									@keypress="onlyAllowNumbers"
								/>
							</v-col>
							<v-col class="item-content">
								<v-select
									v-model="item.displayType"
									:items="displayTypes"
									item-value="code"
									item-text="text"
									label="노출 여부"
									outlined
									@change="updateTypeName(item.displayType, 'displayTypeName', displayTypes)"
								></v-select>
							</v-col>
						</v-row>
						<!-- <v-row>
							<v-col cols="3">
								<v-text-field v-model="item.fontSize" :rules="[v => v >= 10 || '최소 크기는 10입니다']" label="폰트크기" type="number" outlined></v-text-field>
							</v-col>
							<v-col cols="3">
								<v-select
									v-model="item.fontFamilyType"
									:items="fontFamilyTypes"
									item-value="code"
									item-text="text"
									label="폰트 패밀리"
									outlined
									@change="updateTypeName(item.fontFamilyType, 'fontFamilyTypeName', fontFamilyTypes)"
								></v-select>
							</v-col>
							<v-col cols="3">
								<v-select v-model="item.textAlignType" :items="textAlignTypes" item-value="code" item-text="text" label="텍스트 정렬" outlined></v-select>
							</v-col>
							<v-col cols="3">
								<v-text-field
									v-model="item.lineHeight"
									:rules="[v => v >= 1 || '최소 라인 높이는 1입니다']"
									label="라인 높이"
									type="number"
									outlined
								></v-text-field>
							</v-col>
						</v-row> -->
						<v-row>
							<v-col class="item-content">
								<v-select
									v-model="item.displayTimeType"
									:items="displayTimeTypes"
									item-value="code"
									item-text="text"
									label="노출 시간 유형"
									outlined
								></v-select>
							</v-col>
							<v-col class="item-content">
								<v-menu
									ref="menu1"
									v-model="displayStartAtMenu"
									:close-on-content-click="false"
									:return-value.sync="item.displayStartAt"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="displayStartAtString" label="노출 시작 일시" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
									</template>
									<v-card>
										<v-date-picker v-model="displayStartDate" no-title scrollable>
											<v-spacer></v-spacer>
											<v-time-picker v-model="displayStartTime" format="24hr" :allowed-minutes="allowedMinutes"></v-time-picker>
											<v-btn text color="primary" @click="cancelStartAt">Cancel</v-btn>
											<v-btn text color="primary" @click="displayStartAtMenu = false">OK</v-btn>
										</v-date-picker>
									</v-card>
								</v-menu>
							</v-col>
							<v-col class="item-content">
								<v-menu
									ref="menu2"
									v-model="displayEndAtMenu"
									:close-on-content-click="false"
									:return-value.sync="item.displayEndAt"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="displayEndAtString" label="노출 종료 일시" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
									</template>
									<v-card>
										<v-date-picker v-model="displayEndDate" no-title scrollable>
											<v-spacer></v-spacer>
											<v-time-picker v-model="displayEndTime" format="24hr" :allowed-minutes="allowedMinutes"></v-time-picker>
											<v-btn text color="primary" @click="cancelEndAt">Cancel</v-btn>
											<v-btn text color="primary" @click="displayEndAtMenu = false">OK</v-btn>
										</v-date-picker>
									</v-card>
								</v-menu>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
				<v-card-actions class="d-flex justify-right">
					<v-spacer />
					<v-btn rounded :color="$theme.primary" dark elevation="0" @click="saveMessageDialog = true">{{ okButtonText }}</v-btn>
					<v-btn rounded :color="$theme.lightGrey" dark elevation="0" @click="$emit('onCancel')">{{ cancelButtonText }}</v-btn>
					<v-btn v-if="deleteButton" rounded :color="$theme.red" dark elevation="0" @click="$emit('onDelete')">{{ deleteButtonText }}</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

		<MessageDialog
			:show="saveMessageDialog"
			message="저장하시겠습니까?"
			:okButton="true"
			okButtonText="저장"
			:cancelButton="true"
			cancelButtonText="취소"
			@onOk="handleClickSave"
			@onCancel="
				$emit('onCancel');
				saveMessageDialog = false;
			"
		/>

		<!-- 처리중입니다 다이얼로그 -->
		<message-dialog :show="workingStateDialog" message="처리중입니다. 잠시만 기다려주세요." :okButton="false" :cancelButton="false" />

		<v-dialog v-model="searchPostCodeDialog" max-width="600">
			<template>
				<VueDaumPostcode @complete="onComplete" />
			</template>
		</v-dialog>
	</div>
</template>

<script>
	import { VueDaumPostcode } from 'vue-daum-postcode';
	import {
		bannerTypes,
		displayTargetUserTypes,
		displayPositionTypes,
		iconTypes,
		fontFamilyTypes,
		textAlignTypes,
		displayTimeTypes,
		displayTypes,
	} from '@/js/types'; // 절대 경로 사용

	export default {
		name: 'BannerEditDialog',
		components: {
			VueDaumPostcode,
		},
		props: {
			show: {
				default: false,
			},
			icon: {
				default: '',
			},
			modalTitle: {
				default: '',
			},
			deleteButton: {
				default: false,
			},
			okButtonText: {
				default: 'Confirm',
			},
			cancelButtonText: {
				default: 'Cancel',
			},
			deleteButtonText: {
				default: 'Delete',
			},
			item: {
				default: {},
			},
		},
		data: () => ({
			visible: false,
			formValid: false,
			workingStateDialog: false,
			searchPostCodeDialog: false,
			saveMessageDialog: false,
			displayStartAtMenu: false,
			displayEndAtMenu: false,
			displayStartDate: new Date().toISOString().substr(0, 10),
			displayStartTime: '00:00',
			previousStartDate: null,
			previousStartTime: null,
			displayEndDate: new Date().toISOString().substr(0, 10),
			displayEndTime: '00:00',
			previousEndDate: null,
			previousEndTime: null,
			bannerTypes,
			displayTargetUserTypes,
			displayPositionTypes,
			iconTypes,
			fontFamilyTypes,
			textAlignTypes,
			displayTimeTypes,
			displayTypes,
			textContent: '',
		}),
		computed: {
			displayStartAtString() {
				return `${this.displayStartDate} ${this.displayStartTime}`;
			},
			displayEndAtString() {
				return `${this.displayEndDate} ${this.displayEndTime}`;
			},
		},
		watch: {
			async show() {
				this.visible = this.show;
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.resetValidation();
					}
				});
			},
			displayStartAtMenu(val) {
				if (val) {
					this.openStartAtMenu();
				}
			},
			displayEndAtMenu(val) {
				if (val) {
					this.openEndAtMenu();
				}
			},
			// async item() {},
			item: {
				handler() {
					// item이 업데이트될 때 displayStartDate, displayStartTime 초기화
					if (this.item.displayStartAt) {
						let startAt;
						// Firebase Timestamp 형식인지 확인
						if (typeof this.item.displayStartAt.toDate === 'function') {
							startAt = this.item.displayStartAt.toDate();
						} else {
							// 이미 Date 객체라면
							startAt = new Date(this.item.displayStartAt);
						}
						// 로컬 날짜와 시간을 설정 (기본 로케일 사용)
						this.displayStartDate = startAt
							.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
							.replace(/. /g, '-')
							.slice(0, -1);
						this.displayStartTime = startAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
					}

					if (this.item.displayEndAt) {
						let endAt;
						// Firebase Timestamp 형식인지 확인
						if (typeof this.item.displayEndAt.toDate === 'function') {
							endAt = this.item.displayEndAt.toDate();
						} else {
							// 이미 Date 객체라면
							endAt = new Date(this.item.displayEndAt);
						}
						// 로컬 날짜와 시간을 설정 (기본 로케일 사용)
						this.displayEndDate = endAt
							.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
							.replace(/. /g, '-')
							.slice(0, -1);
						this.displayEndTime = endAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
					}
				},
				immediate: true,
			},
		},
		mounted: async function() {
			document.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			updateTypeName(selectedValue, fieldName, typesArray) {
				const selectedItem = typesArray.find(item => item.code === selectedValue);

				if (selectedItem) {
					this.item[fieldName] = selectedItem.text;
				}
			},
			allowedMinutes(val) {
				return val % 30 === 0; // 30분 단위로 선택 가능하게 설정
			},
			handleKeydown(event) {
				if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
					this.$emit('onCancel');
				}
			},
			handleClickSave() {
				this.$refs.form.validate();

				const startAt = new Date(`${this.displayStartDate}T${this.displayStartTime}:00.000`);
				this.item.displayStartAt = this.$database.dateToTimestamp(startAt);

				const endAt = new Date(`${this.displayEndDate}T${this.displayEndTime}:00.000`);
				this.item.displayEndAt = this.$database.dateToTimestamp(endAt);

				if (this.formValid) {
					this.$emit('onOk', this.item);
					this.saveMessageDialog = false;
				}
			},
			validateInteger(value) {
				// 정수로 변환하고 최소값 1을 보장
				this.fontSize = Math.max(parseInt(value, 10), 1);
			},
			onlyAllowNumbers(event) {
				// 숫자와 제어 키(백스페이스, 탭 등)만 허용
				if (!/^[0-9]$/.test(event.key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
					event.preventDefault();
				}
			},
			openStartAtMenu() {
				// v-menu가 열릴 때 현재 값을 임시 저장
				this.previousStartDate = this.displayStartDate;
				this.previousStartTime = this.displayStartTime;
			},
			cancelStartAt() {
				// Cancel 버튼이 눌렸을 때 임시 저장된 값으로 되돌리기
				this.displayStartDate = this.previousStartDate;
				this.displayStartTime = this.previousStartTime;
				this.displayStartAtMenu = false;
			},
			openEndAtMenu() {
				// v-menu가 열릴 때 현재 값을 임시 저장
				this.previousEndDate = this.displayEndDate;
				this.previousEndTime = this.displayEndTime;
			},
			cancelEndAt() {
				// Cancel 버튼이 눌렸을 때 임시 저장된 값으로 되돌리기
				this.displayEndDate = this.previousEndDate;
				this.displayEndTime = this.previousEndTime;
				this.displayEndAtMenu = false;
			},
			onChangeContent(value) {
				this.item.content = value;
			},
			async onComplete(result) {
				this.workingStateDialog = true;
				this.item.address = result.roadAddress;
				this.item.postCode = result.zonecode;
				await this.getGps(this.item.address);
				this.searchPostCodeDialog = false;
				this.workingStateDialog = false;
			},
		},
	};
</script>
